<div class="flex w-full flex-col gap-4 pb-8">
	<div>
		<h1 class="text-3xl font-bold"><span [translate]>Invoices & receipts</span></h1>
		<p class="text-base-content/60 mt-2 text-sm" [translate]>
			Issued by hand, one at a time. A customer asks through a ticket; you build the draft, read it back, and issue it.
		</p>
	</div>

	<div role="tablist" class="tabs tabs-box w-fit">
		@for (tab of tabs; track tab.value) {
			<button role="tab" class="tab" [class.tab-active]="activeTab() === tab.value" (click)="setActiveTab(tab.value)">
				<span [translate]>{{ tab.label }}</span>
			</button>
		}
	</div>

	<!-- New draft -->
	<div class="bg-base-100 border-base-200 rounded-xl border p-4 shadow-sm">
		<div class="mb-3 flex flex-wrap items-baseline justify-between gap-2">
			<h2 class="text-lg font-semibold" [translate]>New draft</h2>
			@if (nextNumber(); as predicted) {
				<span class="text-base-content/60 text-sm">
					<span [translate]>Would be numbered</span> <span class="ml-1 font-mono">{{ predicted }}</span>
					<span class="text-base-content/40"> — <span [translate]>a prediction; nothing is allocated until you issue</span></span>
				</span>
			}
		</div>

		<div class="mb-3 flex flex-wrap items-center gap-3">
			<button class="btn btn-sm btn-outline" (click)="chooseCustomer()">
				<span [translate]>{{ customer() ? 'Change customer' : 'Choose a customer…' }}</span>
			</button>
			@if (customer(); as chosen) {
				<span class="text-sm">{{ chosen.email || chosen.id }}</span>
			} @else {
				<span class="text-base-content/50 text-sm" [translate]>No customer chosen yet.</span>
			}
		</div>

		<!-- The same editor as an existing draft: same actions, same preview, same checks. What it is
		     given is the document the server proposes, which has no row behind it yet. -->
		@if (proposedDocument(); as proposed) {
			<lib-document-draft-panel
				class="block w-full"
				[document]="proposed"
				[kind]="activeTab()"
				[beneficiaryId]="customer()?.id ?? null"
				(created)="onDocumentCreated($event)"
			></lib-document-draft-panel>
		}
	</div>

	<!-- The document, opened in place inside the row that lists it. Everything that can be done to
	     it lives in that component, next to the resource whose repository it calls. -->
	<ng-template #documentPanel let-document>
		<lib-document-draft-panel
			class="block w-full max-w-3xl"
			[document]="documentInHand(document)"
			[kind]="activeTab()"
			(deleted)="onDocumentDeleted()"
			(issued)="onDocumentIssued($event)"
		></lib-document-draft-panel>
	</ng-template>

	<!-- Everything so far. Clicking a row opens it, and the panel above is what it opens into. -->
	<div>
		<p class="text-base-content/50 mb-2 text-sm" [translate]>Click a row to open it — a draft can still be previewed, edited, deleted or issued.</p>
		@if (activeTab() === 'invoice') {
			<lib-invoice-table class="block w-full" bypass-acls="true" click-behavior="expand" [expandedRow]="documentPanel" [queryForSearchPatternInUrl]="'admin-invoices'"></lib-invoice-table>
		} @else {
			<lib-receipt-table class="block w-full" bypass-acls="true" click-behavior="expand" [expandedRow]="documentPanel" [queryForSearchPatternInUrl]="'admin-receipts'"></lib-receipt-table>
		}
	</div>
</div>
